import axios from "./index.service";

export default class DocumentInstructionService {
  static fetchAllDocumentInstructions() {
    return axios({
      method: "GET",
      url: `/api/services/v1/document_management/document-type-instructions`,
    });
  }

  static fetchDocumentInstructions(document_type) {
    return axios({
      method: "GET",
      url: `/api/services/v1/document_management/document-type-instructions/${document_type}`,
    });
  }

  static getDocumentFee(fee_type) {
    return axios({
      method: "GET",
      url: `/api/services/v1/document_management/document-type-instructions/${fee_type}`,
    });
  }

  static addDocumentInstructions(document_type, payload) {
    return axios({
      method: "POST",
      url: `/api/services/v1/document_management/add-instructions/${document_type}`,
      data: payload,
    });
  }

  static getDocumentList() {
    return axios({
      method: "GET",
      url: `/api/services/v1/document-processing/`,
    });
  }

  static getUserDocumentList() {
    return axios({
      method: "GET",
      url: `/api/services/v1/document-processing/user-documents-processing`,
    });
  }

  static processDocument(payload) {
    return axios({
      method: "POST",
      url: `/api/services/v1/document-processing/`,
      data: payload,
    });
  }

  static approveOrDisapprove(payload) {
    const { id, action } = payload;
    const requestAction = action === "approval" ? "approve" : "disapprove";
    return axios({
      method: "PATCH",
      url: `/api/services/v1/document-processing/${requestAction}/${id}`,
    });
  }

  static getDocument(id) {
    return axios({
      method: "GET",
      url: `/api/services/v1/document-processing/${id}`,
    });
  }

  static getProcessingFee(payload) {
    return axios({
      method: "POST",
      url: `/api/services/v1/document-processing/processing-fee`,
      data: payload,
    });
  }

  static attachedDocument(payload) {
    return axios({
      method: "POST",
      url: `/api/services/v1/document_management/attach-document`,
      data: payload,
    });
  }

  static getAllUserAttachedDocuments() {
    return axios({
      method: "GET",
      url: `/api/services/v1/document_management/user-attached-documents`,
    });
  }

  static getAllUserAttachedDocumentsByType(type) {
    return axios({
      method: "GET",
      url: `/api/services/v1/document_management/user-attached-documents/${type}`,
    });
  }

  static deleteAttachedDocument(id) {
    return axios({
      method: "DELETE",
      url: `/api/services/v1/document_management/delete-attached-document/${id}`,
    });
  }

  static getCountries() {
    return axios({
      baseURL: `https://countriesnow.space/api/v0.1`,
      method: "GET",
      url: `/countries/`,
    });
  }

  static getRequiredDocuments(isMisplacedDocument) {
    return axios({
      method: "GET",
      url: `/api/services/v1/document-processing/required-documents`,
      params: { isMisplacedDocument: isMisplacedDocument },
    });
  }

  static updateTrackingStatus(payload) {
    return axios({
      method: "PATCH",
      url: `/api/services/v1/document-processing/update-tracking-status`,
      data: payload,
    });
  }

  static getDocumentTrackingStatus(documentId) {
    return axios({
      method: "GET",
      url: `/api/services/v1/document-processing/get-document-tracking-status`,
      params: {
        documentId: documentId,
      },
    });
  }
}
